import { PropsWithChildren, createContext, useContext } from 'react';

import { Value } from '@spotify-confidence/sdk';

export type FlagValueResolver = <T extends Value>(
  flag: string,
  defaultValue: T,
) => T;

const useDefaultFlagValue = <T extends Value>(
  _flag: string,
  defaultValue: T,
): T => defaultValue;

const FlagResolverContext =
  createContext<FlagValueResolver>(useDefaultFlagValue);

export type FlagResolverProviderProps = PropsWithChildren<{
  resolver: FlagValueResolver;
}>;

export const FlagResolverProvider = ({
  resolver,
  children,
}: FlagResolverProviderProps) => (
  <FlagResolverContext.Provider value={resolver}>
    {children}
  </FlagResolverContext.Provider>
);

export const useFlagResolver = (): FlagValueResolver =>
  useContext(FlagResolverContext);
